import React from 'react';
import {PasswordLessLogin} from './container';

export const PasswordLessScreen = ({navigation}: {navigation: any}) => {
  return <PasswordLessLogin />;
};
